// extracted by mini-css-extract-plugin
export default {"container":"TicketsAccordionLoadingSkeleton-module__container___3FQFv"};